module.exports = __webpack_public_path__ + "img/2.77a14f3f.png";